import styled from "styled-components";
import { Text } from "src/apps/components/typography/Texts";
import { T } from "src/apps/components/i18n/Translation";

import { AvailableActor } from "src/contexts/documentationArea/domain/AvailableActor";
import { ActorId } from "src/contexts/documentationArea/domain/ActorId";
import { ActorItem } from "./ActorItem";
import { colors } from "@permisso/permisso-components";

const ACTOR_SELECTOR_OWN_SECTION = "documentation_area.actor_selector.own_section";
const ACTOR_SELECTOR_OTHER_SECTIONS = "documentation_area.actor_selector.other_sections";

interface ActorSelectorContentProps {
  availableActors: AvailableActor[];
  selectedActor: AvailableActor | null;
  onSelectActor: (actorId: ActorId) => void;
}

export const ActorSelectorContent = ({
  availableActors,
  selectedActor,
  onSelectActor,
}: ActorSelectorContentProps) => {
  const ownSectionActors = availableActors.filter((actor) => !actor.readOnly);
  const readOnlyActors = availableActors.filter((actor) => actor.readOnly);

  return (
    <>
      <SectionTitle>
        <T k={ACTOR_SELECTOR_OWN_SECTION} />
      </SectionTitle>
      {ownSectionActors.map((ownSectionActor) => (
        <ActorItem
          key={ownSectionActor.id}
          actor={ownSectionActor}
          isSelected={selectedActor?.id === ownSectionActor.id}
          isOwner={true}
          onSelect={onSelectActor}
        />
      ))}

      {readOnlyActors.length ? <SectionDivider /> : null}
      {readOnlyActors.length ? (
        <SectionTitle>
          <T k={ACTOR_SELECTOR_OTHER_SECTIONS} />
        </SectionTitle>
      ) : null}
      {readOnlyActors.map((readOnlyActor) => (
        <ActorItem
          key={readOnlyActor.id}
          actor={readOnlyActor}
          isSelected={selectedActor?.id === readOnlyActor.id}
          isOwner={false}
          onSelect={onSelectActor}
        />
      ))}
    </>
  );
};

const SectionTitle = styled(Text)`
  color: ${colors.grey700};
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
  padding: 0.875rem 1rem 0.5rem 1rem;
`;

const SectionDivider = styled.div`
  border-bottom: 1px solid ${colors.grey400};
  margin: 0.625rem 1rem;
`;
